export default __webpack_public_path__ + "static/media/banner_sidemenu.dd4e8933.png";